module.exports = __webpack_public_path__ + "static/media/Business Plan-pana.1a4bae45.svg";